// extracted by mini-css-extract-plugin
export var blocks = "styles-module--blocks--gWiEw";
export var block = "styles-module--block--h1nQD";
export var blockImage = "styles-module--blockImage--CSsln";
export var blockContent = "styles-module--blockContent--GywFC";
export var blockTitle = "styles-module--blockTitle--4imey";
export var blockDesc = "styles-module--blockDesc--B9RZe";
export var button = "styles-module--button--pZdER";
export var container = "styles-module--container--vCxTl";
export var title = "styles-module--title--sR6mY";